<template>
  <div
    class="p-5 text-sm"
    :class="activeRoleContent.banner ? 'pb-0' : 'border-b border-chrome-light'"
  >
    <p class="font-semibold mb-1">
      Welcome to the Living IDP Portal!
    </p>

    <div class="[&_*]:leading-[17px]">
      <p
        class="mb-0"
        :class="isViewer ? 'w-full' : 'w-[93%]'"
      >
        {{ activeRoleContent.description }}
      </p>

      <div
        v-if="activeRoleContent.banner"
        class="flex items-center bg-secondary-subtle text-black font-medium min-h-[50px] px-5 py-4 mt-4 -mx-5"
      >
        <span v-html="sanitize(activeRoleContent.banner)" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

import { useDomPurify, usePlanOverviewRole } from '@/composables';
import { useAuthStore } from '@/store';
import { Role } from '@/const';

const props = defineProps({
  workflowStep: {
    type: String,
    required: true,
  },
});

const authStore = useAuthStore();
const { sanitize } = useDomPurify();
const { getActiveRoleContent } = usePlanOverviewRole();

const activeRoleContent = computed(() => getActiveRoleContent(props.workflowStep));
const isViewer = computed(() => authStore.user?.roles?.includes(Role.Viewer));
</script>
